import React from 'react'
import Menu from './Menu'
import HeaderCat from './HeaderCat'
import '../assets/suivreMaCommande.css'
import Contact from './Contact'
import Footer from './Footer'

function SuivreMaCommande() {
  return (
    <div>
        <Menu />
        <HeaderCat title={ "SUIVRE MA COMMANDE" } image={"/images/commande.png"} subtitle={ 'Avec votre numéro de ... voyez où en est la livraison'} />
        <div className="container" id='commande'>
            <span>SUIVI DE COMMANDE</span>
            <h1>OÙ EST MA COMMANDE ?</h1>
            <p className='p1'>Avec le mode de livraison Chronopost, la livraison express en 24h est garantie.</p>
            <p className='p2'>Renseignez le n° de suivi ou d'avis de passage de 11 à 15 caractères</p>
            <div className='imgs'>
              <img src={window.location.origin +"/images/commande1.png"} alt="" />
              <img src={window.location.origin +"/images/commande2.png"} alt="" />
            </div>
            <div className="search mb-3">
              <input type="text" placeholder='Ex : 6Q2467TGEY88' />
              <button>Rechecher</button>
            </div>
        </div>
        <Contact />
        <Footer />
    </div>
  )
}

export default SuivreMaCommande